import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-144">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-145" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-900/40 rounded-full blur-[120px] pointer-events-none" data-id="element-146" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-147">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-148">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-149">
            <FadeIn delay={0.1} data-id="element-150">
              <span className="inline-block py-1 px-3 rounded-full bg-gold-500/10 text-gold-500 text-sm font-semibold tracking-wider uppercase mb-6 border border-gold-500/20" data-id="element-151">
                Plan de 60 días
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-152">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-153">
                Finanzas Sin{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-154">
                  Excusas
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-155">
              <p className="text-xl md:text-2xl text-slate-300 mb-8 font-light leading-relaxed" data-id="element-156">
                Plan de 60 días para ordenar tu dinero (aunque estés cansada y
                sin tiempo).
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-157">
              <p className="text-lg text-white font-medium mb-10 border-l-4 border-gold-500 pl-4 py-1" data-id="element-158">
                Quieres control real, sin culpas y sin fórmulas mágicas.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-159">
              <a href="https://reckiva.com/cart/48040237727844:1" target="_blank" rel="noopener noreferrer" className="btn-gold w-full sm:w-auto group" onClick={trackAddToCart} data-id="element-160">
                Sí, quiero ordenar mis finanzas
                <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-161" />
              </a>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-id="element-162">
            <FadeIn delay={0.4} direction="left" data-id="element-163">
              <div className="relative group" data-id="element-164">
                {/* Image glow effect */}
                <div className="absolute -inset-4 bg-gradient-to-r from-gold-500/20 to-teal-900/40 rounded-xl blur-xl group-hover:blur-2xl transition-all duration-500 opacity-70" data-id="element-165" />

                <img src="https://cdn.magicpatterns.com/uploads/uCVABsLvpQKgj2t7LZVVye/heylloyd-image-1773084753327.png" alt="Portada del eBook Finanzas Sin Excusas" className="relative z-10 w-full max-w-md rounded-lg shadow-2xl shadow-black/50 transform transition-transform duration-500 group-hover:scale-[1.02] border border-white/10" data-id="element-166" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}